module.exports = __webpack_public_path__ + "static/media/plan_bone.01d59eda.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/plan_bone.svg
// module id = 353
// module chunks = 0